<div class="title">
  <p>{{ "TRANSFORMERS.FULL_NAME" | translate }}</p>
  <div
  class="ml-auto d-flex align-items-center"
  style="position: relative"
  *ngIf="
    permissionsService.isTransformersCreateEditCrudAllowed &&
    utilityId != 0 &&
    bpsAdminLevel != 2
  "
>
  <!-- Upload Dugme -->
  <button
    class="btn btn-primary btn-upload"
    (click)="showUpload = !showUpload"
    click-stop-propagation
  >
    <img src="../../assets/icons/chevron-down.svg" alt="Chevron down" />
  </button>

  <div
    *ngIf="showUpload"
    class="xlsx-upload"
    [routerLink]="'/upload/7/' + utilityId"
  >
    <div><img src="../../assets/icons/upload-arrow.svg" /></div>
    <div>{{ "COMMON.UPLOAD_XLSX" | translate }}</div>
  </div>

  <!-- Add New Dugme -->
  <button
    class="btn btn-primary btn-add-new"
    (click)="addNew()"
    data-bs-target="#addNewDt"
    data-bs-toggle="modal"
  >
    <img src="../../assets/icons/plus.svg" alt="Plus icon" />
    <span>{{ "CRUD_SETTINGS.ADD_NEW" | translate }}</span>
  </button>

  <!-- Download Dugme -->
  <button
    type="button"
    class="btn btn-secondary btn-download"
    (click)="download()"
    *ngIf="permissionsService.isF11CreateEditAllowed"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 10.5L11.5 7L10.25 5.75L9 7V3H7V7L5.75 5.75L4.5 7L8 10.5ZM2 14H14V12H2V14Z"
        fill="white"
      />
    </svg>
    {{ "CRUD_SETTINGS.DOWNLOAD" | translate }}
  </button>
</div>

</div>
<div class="filter">
  <div class="filter-list">
    {{ "COMMON.FILTER" | translate }}
    <app-multi-select-dropdown
      class="multiselect"
      [clicked]="clicked"
      [items]="areas"
      [label]="utName + 's'"
      [showMore]="false"
      [requireApply]="true"
      (shareIndividualCheckedList)="selectDistrict($event)"
      (applyFilterEmitter)="reloadTable()"
    >
    </app-multi-select-dropdown>
    <select
      name="voltage"
      (change)="selectFeederVoltage($event)"
      class="form-select"
    >
      <option value="0" [selected]="feederVoltage == 0" disabled>
        {{ "COMMON.FEEDER_VOLTAGE" | translate }}
      </option>
      <option *ngFor="let o of feederVoltageOptions" value="{{ o.value }}">
        {{ o.name }}
      </option>
    </select>
    <input
      style="padding-left: 0.2rem"
      type="text"
      placeholder="Feeder Name"
      class="feederName"
      [(ngModel)]="feederName"
      (keydown.enter)="selectFeederName()"
      (ngModelChange)="this.feederNameUpdate.next($event)"
    />
  </div>
  <div *ngIf="selectedFilters.length > 0">
    <app-filter-checklist
      [filters]="selectedFilters"
      (resetFilterEmitter)="resetFilter($event)"
      (removeFilterEmitter)="removeFilter($event)"
    >
    </app-filter-checklist>
  </div>
</div>
<div class="container-fluid border-bottom">
  <table>
    <tr class="header-row">
      <th>{{ "COMMON.DT_NAME" | translate }}</th>
      <th>{{ "COMMON.DT_NUMBER" | translate }}</th>
      <th>{{ "COMMON.UT.SINGLE" | translate }}</th>
      <th>{{ "COMMON.MBC_DETAILS.FEEDER_NAME" | translate }}</th>
      <th>Code</th>
      <th>{{ "COMMON.LATITUDE" | translate }}</th>
      <th>{{ "COMMON.LONGITUDE" | translate }}</th>
      <th>{{ "TRANSFORMERS.EDIT.METER_NUM" | translate }}</th>
      <th>{{ "TRANSFORMERS.EDIT.METER_BRAND" | translate }}</th>
      <th></th>
      <th></th>
    </tr>
    <tr class="content-wrapper" *ngFor="let dt of dts">
      <td
        data-bs-toggle="modal"
        data-bs-target="#addNewDt"
        (click)="
          permissionsService.isTransformersCreateEditCrudAllowed
            ? selectDt(dt)
            : null
        "
      >
        {{ dt.name | hasValue }}
      </td>
      <td
        data-bs-toggle="modal"
        data-bs-target="#addNewDt"
        (click)="
          permissionsService.isTransformersCreateEditCrudAllowed
            ? selectDt(dt)
            : null
        "
      >
        {{ dt.number | hasValue }}
      </td>
      <td
        data-bs-toggle="modal"
        data-bs-target="#addNewDt"
        (click)="
          permissionsService.isTransformersCreateEditCrudAllowed
            ? selectDt(dt)
            : null
        "
      >
        {{ dt.area.name | hasValue }}
      </td>
      <td
        data-bs-toggle="modal"
        data-bs-target="#addNewDt"
        (click)="
          permissionsService.isTransformersCreateEditCrudAllowed
            ? selectDt(dt)
            : null
        "
      >
        {{ dt?.feeder?.name | hasValue }}
      </td>
      <td>{{ dt.code | hasValue }}</td>
      <td>{{ dt.latitude | hasValue }}</td>
      <td>{{ dt.longitude | hasValue }}</td>
      <td
        data-bs-toggle="modal"
        data-bs-target="#addNewDt"
        (click)="
          permissionsService.isTransformersCreateEditCrudAllowed
            ? selectDt(dt)
            : null
        "
      >
        {{ dt.meterNumber | hasValue }}
      </td>
      <td
        data-bs-toggle="modal"
        data-bs-target="#addNewDt"
        (click)="
          permissionsService.isTransformersCreateEditCrudAllowed
            ? selectDt(dt)
            : null
        "
      >
        {{ getMeterBrandName(dt.meterBrandId) | hasValue }}
      </td>
      <td class="td-svg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width="22"
          height="22"
          data-bs-toggle="modal"
          data-bs-target="#history"
          (click)="viewHistory(dt.id)"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
          />
        </svg>
      </td>
      <td class="td-svg">
        <svg
          *ngIf="
            permissionsService.isTransformersDeleteAllowed && bpsAdminLevel != 2
          "
          data-bs-toggle="modal"
          data-bs-target="#deleteDt"
          (click)="
            permissionsService.isTransformersCreateEditCrudAllowed
              ? selectDt(dt)
              : null
          "
          width="22"
          height="22"
          viewBox="0 0 22 22"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
            fill="#DE350B"
          />
        </svg>
      </td>
    </tr>
  </table>
</div>
<div>
  <app-paging
    *ngIf="count > 0"
    [pageSize]="pageSize"
    [count]="count"
    [currentPage]="currentPage"
    (pageChange)="pageChange($event)"
  ></app-paging>
</div>

<div
  class="modal fade"
  id="addNewDt"
  tabindex="-1"
  aria-hidden="true"
  *ngIf="permissionsService.isTransformersCreateEditCrudAllowed"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ actionLabel$ | async }} {{ "TRANSFORMERS.FULL_NAME" | translate }}
        </h5>
        <button
          type="button"
          #closeAddModal
          class="btn-cancel-modal"
          data-bs-dismiss="modal"
        >
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <form
        id="addForm"
        class="form-wrapper"
        ngNativeValidate
        (submit)="saveOrUpdate()"
      >
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input
              id="dtName"
              name="name"
              type="text"
              [(ngModel)]="selectedDt.name"
              class="form-control"
              required
              placeholder=" "
            />
            <label for="dtName">{{ "COMMON.DT_NAME" | translate }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <input
              id="dtNumber"
              name="number"
              type="text"
              [(ngModel)]="selectedDt.number"
              class="form-control"
              required
              placeholder=" "
            />
            <label for="dtNumber">{{ "COMMON.DT_NUMBER" | translate }}</label>
          </div>
          <div class="form-item form-floating mb-3">
             <app-dropdown-search
                [items]="areas"
                label="COMMON.UT.SINGLE"
                id="areas-dropdown"
                [selectedItemId]="selectedAreaId || null"
                [reset]="resetDropdownSearch"
                (selectedIdChange)="selectArea($event)"
              ></app-dropdown-search>
          </div>
          <div class="form-item form-floating mb-3">
            <select
              [ngClass]="feederType !== -1 ? 'selected-option' : ''"
              name="selecFeederType"
              (change)="selectFeederType($event)"
              required
              class="form-select"
            >
              <option value="" [selected]="feederType === -1" disabled>
                {{ "COMMON.FEEDER_TYPE" | translate }}
              </option>
              <option value="KV11" [selected]="feederType === 0">11KV</option>
              <option value="KV33" [selected]="feederType === 1">33KV</option>
            </select>
            <label
              *ngIf="feederType !== -1"
              class="label-for-select"
              for="floatingSelect"
              >{{ "COMMON.FEEDER_TYPE" | translate }}</label
            >
            <div *ngIf="feederType !== -1" class="select-title"></div>
          </div>
          <div class="form-item form-floating mb-3">
            <app-dropdown-search *ngIf="feeders.length > 0"
                [items]="feeders"
                label="COMMON.FEEDER"
                id="feeders-dropdown"
                [selectedItemId]="selectedFeederId || null"
                [reset]="resetDropdownSearch"
                (selectedIdChange)="selectFeeder($event)"
              ></app-dropdown-search>
          </div>
          <div class="form-item form-floating mb-3">
            <input
              id="dtLatitude"
              name="latitude"
              type="number"
              step="any"
              min="-90"
              max="90"
              [(ngModel)]="selectedDt.latitude"
              class="form-control"
              placeholder=" "
            />
            <label for="dtLatitude">{{ "COMMON.LATITUDE" | translate }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <input
              id="dtLongitude"
              name="longitude"
              type="number"
              step="any"
              min="-180"
              max="180"
              [(ngModel)]="selectedDt.longitude"
              class="form-control"
              placeholder=" "
            />
            <label for="dtLongitude">{{ "COMMON.LONGITUDE" | translate }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <input
              id="dtMeterNumber"
              name="meterNumber"
              type="text"
              [(ngModel)]="selectedDt.meterNumber"
              class="form-control"
              placeholder=" "
            />
            <label for="dtMeterNumber">{{ "TRANSFORMERS.EDIT.METER_NUM" | translate }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <select
              [ngClass]="selectedDt.meterBrandId ? 'selected-option' : ''"
              name="meterBrand"
              (change)="selectMeterBrand($event)"
              class="form-select"
            >
              <option value="" [selected]="!selectedDt.meterBrandId" disabled>
                {{ "TRANSFORMERS.EDIT.METER_BRAND" | translate }}
              </option>
              <option
                *ngFor="let brand of meterBrands"
                [selected]="selectedDt.meterBrandId === brand.id"
                value="{{ brand.id }}"
              >
                {{ brand.name }}
              </option>
            </select>
            <label
              *ngIf="selectedDt.meterBrandId"
              class="label-for-select"
              for="floatingSelect"
              >{{ "TRANSFORMERS.EDIT.METER_BRAND" | translate }}</label
            >
            <div *ngIf="selectedDt.meterBrandId" class="select-title"></div>
          </div>
        </div>
        <div class="modal-footer" *ngIf="bpsAdminLevel != 2">
          <button class="btn btn-primary" form="addForm">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteDt" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "TRANSFORMERS.DT" | translate }}?
        </h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="deleteDt()">
          {{ "COMMON.DELETE" | translate }}
        </button>
        <button
          #closeDeleteModal
          hidden="true"
          data-bs-dismiss="modal"
        ></button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="reattachDt"
  tabindex="-1"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "CRUD_SETTINGS.RELATED_DT_CANNOT_DELETE" | translate }}<br />
          {{ "CRUD_SETTINGS.RELATED_DT_OPTIONS" | translate }}
        </h5>
      </div>
      <form id="reattachForm" class="form-wrapper">
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input
              id="dtName"
              name="searchDtName"
              type="text"
              (click)="onInputClick()"
              (keyup)="filterOptions()"
              [(ngModel)]="reattachDt.name"
              class="form-control"
              required
              placeholder=" "
              autocomplete="off"
            />
            <label for="dtName">{{ "COMMON.DT_NAME" | translate }}</label>
          </div>
          <div #optionsList *ngIf="showOptions" class="dropdown-list">
            <span
              *ngFor="let dt of searchedDts"
              (click)="onOptionClick($event, dt)"
              [ngClass]="dt.slrn != null ? 'search-items bold' : 'search-items'"
              >{{ dt.name }}</span
            >
          </div>
          <div class="modal-footer">
            <button
              type="button"
              form="reattachForm"
              class="btn btn-danger"
              (click)="submitReattach()"
            >
              {{ "COMMON.REATTACH" | translate }}
            </button>
            <button
              #openReattachModal
              hidden="true"
              data-bs-toggle="modal"
              data-bs-target="#reattachDt"
            ></button>
            <button
              #closeReattachModal
              hidden="true"
              data-bs-dismiss="modal"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<button
  class="btn btn-primary"
  #openUpdateDescriptionModal
  data-bs-toggle="modal"
  data-bs-target="#history"
  hidden
></button>
<app-history
  [isViewHistory]="isViewHistory"
  [historyItems]="historyItems"
  (update)="updateHistory($event)"
></app-history>
